const BaseUrl = process.env.REACT_APP_API_BASE_URL
const ImageUrl = process.env.REACT_APP_IMAGE_BASE_URL

export { BaseUrl, ImageUrl };
